<template>
  <div class="banner">
    <div class="swiper-container banner-container">
      <div class="swiper-wrapper">
        <!-- :style="{backgroundImage: 'url(' + banner + ')', backgroundSize:'cover'}" -->
        <div
          class="swiper-slide"
          v-for="(item, index) in list.list"
          :key="index"
          :style="{
            backgroundImage: 'url(' + item.img_url_temp + ')',
            minHeight: myHeight + 'px',
          }"
        >
          <img class="banner-img" :src="item.img_url_temp" alt="" />
        </div>
      </div>
      <div class="hadFrom">
        <div class="hadFrom-main">
          <!-- <img src="@/assets/image/logo.png" alt="title" /> -->
          <p class="title" v-html="list.title"></p>
          <p class="sTitle" v-html="list.desc"></p>
          <a-input-search
            v-if="hadFrom"
            placeholder="请输入您的手机号"
            v-model="phone"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            size="large"
            @search="setMessage"
            class="input-box"
          >
            <a-button class="btn" type="primary" slot="enterButton"
              >免费获取报价</a-button
            >
          </a-input-search>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      phone: "",
      // banner: [
      // 	require("@/assets/image/banner.jpg"),
      // 	require("@/assets/image/banner1.jpg"),
      // 	require("@/assets/image/banner2.jpg")
      // ],
    };
  },
  props: {
    hadFrom: {
      type: Boolean,
      default: false,
    },
    // 最小高度
    myHeight: {
      type: Number,
      default: 220,
    },
    list: {
      type: Object,
      default: {
        title: "",
        desc: "",
        list: [],
      },
    },
  },
  methods: {
    setMessage() {
      let source_url = window.location.href;
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$message.error("请输入正确手机号");
        return;
      }
      let data = {
        channel: 10,
        phone: this.phone,
        source_url: source_url,
      };
      if (this.$mobile) {
        data.channel = 20;
      }
      this.$api.applyOffer(data).then((res) => {
        this.$message.success("提交成功，稍后专业顾问将为你提供专业报价");
        this.phone = "";
      });
    },
    _init_swiper() {
      var swiper = new Swiper(".banner .banner-container", {
        autoplay: 2000,
        loop: false,
      });
    },
    onSearch() {},
  },
  mounted() {
    setTimeout(() => {
      this._init_swiper();
    }, 1000);
  },
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "HYYaKuHeiW";
  src: url(../../assets/font/HYYaKuHeiW.ttf);
  font-weight: normal;
  font-style: normal;
}

@import "@/assets/css/public.scss";
</style>
